import { Box, Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { Text } from '@revelio/ui';

import styles from './data-builder-step-layout.module.css';

type DataBuilderStepLayoutProps = {
  title: ReactNode;
  titleActions?: ReactNode;
  noGutter?: boolean;
  footer?: ReactNode;
  children: ReactNode;
};

export const DataBuilderStepLayout = ({
  title,
  titleActions,
  noGutter,
  footer,
  children,
}: DataBuilderStepLayoutProps) => (
  <Flex as="section" direction="column" height="100%">
    <Flex
      as="header"
      className={styles.header}
      align="center"
      justify="space-between"
      gap="4"
      flexShrink={0}
      borderBottom="1px solid #f0f2f5"
      p="4"
    >
      <Text as="h2" weight="semibold" fontSize="bg">
        {title}
      </Text>
      {titleActions && <Box>{titleActions}</Box>}
    </Flex>
    <Box
      flex={1}
      minHeight={0}
      overflow="auto"
      pt="4"
      px={noGutter ? '0' : '4'}
    >
      {children}
    </Box>
    {footer}
  </Flex>
);
